// Assistant responses sometimes pack numbered-list items onto a single line
// ("Meds: 1. Metoprolol 2. Lisinopril"). remark-gfm only renders an ordered
// list when each marker starts its own line, so we insert a newline before a
// genuine "N. " marker.
//
// The marker must be preceded by whitespace whose prior character is NOT a
// digit, dot or hyphen. That negative lookbehind is what keeps numbers embedded
// in dates ("2026-08-25. Allergies"), decimals ("3.5 mg") and version strings
// from being mistaken for list markers — the earlier `/(\s*\d+\.\s)/g` form
// matched the "25. " inside a date and produced a stray "1." list item.
const LIST_MARKER_RE = /(?<![\d.\-])(\s+)(\d+\.\s)/g;

export function normalizeListMarkers(input: string | null | undefined): string {
  return (input || "").trim().replace(LIST_MARKER_RE, "\n$2");
}
